import { useEffect, useState, useRef } from "react";
import AppConst from "../apis/appconst";
import axios from "axios";
import { toast } from "react-toastify";
import Swal from "sweetalert2";
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import Select from "react-select";


function AddSale2() {
    const dropdownRef = useRef(null);
    const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    const [ldata, setLdata] = useState(null);
    const otDocRef = useRef();
    const referralDocRef = useRef();
    const [searchTerm, setSearchTerm] = useState('');
    const [showReferralDropdown, setShowReferralDropdown] = useState(false);
    const [showReferralDoctorDropdown, setShowReferralDoctorDropdown] = useState(false);
    const [showDropdown, setShowDropdown] = useState(false);
    const [isUHIDReadOnly, setIsUHIDReadOnly] = useState(false);
    const [originalLabRegType, setOriginalLabRegType] = useState("");
    const [medicineSearch, setMedicineSearch] = useState("");
    const [showMedicineOptions, setShowMedicineOptions] = useState(false);
    const [image, setImage] = useState('');
    const [expiringMedicines, setExpiringMedicines] = useState([]);
const [showExpiryAlert, setShowExpiryAlert] = useState(false);
    const [formData, setFormData] = useState({
        medicines: [
            {
                sn: 1,
                med_bill_item_medicine: '',
                med_bill_item_batch: '',
                med_bill_item_qty: '',
                med_bill_item_strips: '',
                med_bill_item_is_loose: '',
                med_bill_item_exp: '',
                med_bill_item_mrp: '',
                med_bill_item_discount: '',
                med_bill_item_discount_amt: '',
                med_bill_item_tax: '',
                med_bill_item_tax_amt: '',
                med_bill_item_total: '',
            }
        ],
        medicineList:[],
        med_bill_id: '',
        med_bill_date: '',
        med_bill_type:'normal',
        med_bill_ipd_number: '',
        med_bill_patient_number: '',
        med_bill_doctor: '',
        med_bill_ref_doctor: '',
        med_bill_phone_number: '',
        med_bill_address_of_patient: '',
        med_bill_gst_number: '',
        med_bill_drug_licence_no: '',
        med_bill_discount: '',
        med_bill_discount_amt: '',
        med_bill_mode_of_payment: '',
        med_bill_total: '',
        med_bill_final_amt: '',
        med_bill_paid: '',
        med_bill_payment_mode: '',
        med_bill_remarks: '',
        med_bill_due: '',
        med_bill_user: '',
        total_qty : '',
        docs: [],
        vitals: [],
        page_no: 0,
        alertMsg: '',
        alertMsgTyp: '',
        search_key: '',
        isAlert: false,
    });
    const loadDoctors = async () => {
        try {
            const fd = new FormData();
            fd.append("type", "doctor");
            fd.append("search_key", "");
            fd.append("page_no", "none");
    
            const res = await axios.post(
                AppConst.BASE_URL + AppConst.getUserListUrl,
                fd,
                { headers: { "Content-Type": "multipart/form-data" } }
            );
    
            if (res.data.status) {
                setFormData(prev => ({
                    ...prev,
                    docs: res.data.records || []
                }));
            }
        } catch (err) {
            console.error("Doctor load error", err);
        }
    };
    
    const handleChange = (e) => {
        const { name, value } = e.target;

        setFormData(prev => {
            const newState = { ...prev, [name]: value };

            if (name === "lab_reg_type") {
                if (value !== originalLabRegType) {
                    setIsUHIDReadOnly(false);
                } else {
                    setIsUHIDReadOnly(true);
                }
            }

            return newState;
        });
    };

    const handleChange1 = (e,index) => {
        if (!e || !e.target) return;
        const { name, value } = e.target;
        const name1 = name.replace(/[0-9]/g, "");

        setFormData(prev => {
            const updatedItems = [...prev.medicines];
            updatedItems[index] = {
                ...updatedItems[index],
                [name1]: value
            };
        
            return {
                ...prev,
                medicines: updatedItems
            };
        });
    };
// Format Bill Number with leading zeros
const formatBillNo = (billId) => {
    if (!billId) return '-';
    return String(billId).padStart(3, '0');
};
    const fetchConfigData = async () => {
        try {
            const res = await axios.post(
                `${AppConst.BASE_URL + AppConst.getconfig}?config_type=lab`
            );

            if (res.data.status) {
                const data = res.data;
                setImage(data.header_logo);
            }
        }
        catch (err) {
            console.error("Error fetching config:", err);
        }
    };

    const imageUrlToBase64 = async (url) => {
        if (!url) {
            console.error("Image URL is empty or invalid.");
            return null;
        }

        try {
            const response = await fetch(url);
            if (!response.ok) {
                console.error(`Failed to fetch image. Status: ${response.status} ${response.statusText}`);
                return null;
            }

            const blob = await response.blob();

            if (!blob.type.startsWith('image/')) {
                console.error(`The provided URL did not point to an image. It pointed to a file of type: ${blob.type}`);
                return null;
            }

            return new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.onloadend = () => resolve(reader.result);
                reader.onerror = reject;
                reader.readAsDataURL(blob);
            });
        } catch (error) {
            console.error("Error fetching or converting image:", error);
            return null;
        }
    };

    const numberToWords = (num) => {
        if (num === null || num === undefined || isNaN(num)) return '';
    
        num = Math.round(Number(num));
    
        const a = ['', 'one ', 'two ', 'three ', 'four ', 'five ', 'six ', 'seven ', 'eight ', 'nine ',
            'ten ', 'eleven ', 'twelve ', 'thirteen ', 'fourteen ', 'fifteen ',
            'sixteen ', 'seventeen ', 'eighteen ', 'nineteen '];
    
        const b = ['', '', 'twenty ', 'thirty ', 'forty ', 'fifty ',
            'sixty ', 'seventy ', 'eighty ', 'ninety '];
    
        if (num === 0) return 'Zero Only';
    
        if (num.toString().length > 9) return 'Overflow';
    
        const n = ('000000000' + num)
            .slice(-9)
            .match(/^(\d{2})(\d{2})(\d{2})(\d{1})(\d{2})$/);
    
        if (!n) return '';
    
        let str = '';
    
        str += (n[1] != 0) ? (a[Number(n[1])] || b[n[1][0]] + a[n[1][1]]) + 'Crore ' : '';
        str += (n[2] != 0) ? (a[Number(n[2])] || b[n[2][0]] + a[n[2][1]]) + 'Lakh ' : '';
        str += (n[3] != 0) ? (a[Number(n[3])] || b[n[3][0]] + a[n[3][1]]) + 'Thousand ' : '';
        str += (n[4] != 0) ? (a[Number(n[4])] || b[n[4][0]] + a[n[4][1]]) + 'Hundred ' : '';
        str += (n[5] != 0)
            ? ((str !== '') ? 'And ' : '') + (a[Number(n[5])] || b[n[5][0]] + a[n[5][1]])
            : '';
    
        return str.trim()
            .replace(/\s+/g, ' ')
            .replace(/\b\w/g, l => l.toUpperCase()) + ' Only';
    };
    const fetchExpiringMedicines = async () => {
        try {
            const response = await axios.post(
                AppConst.BASE_URL + AppConst.getExpiringMedicinesUrl,
                {},
                {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                    },
                }
            );
    
            if (response.data.status) {
                const medicines = response.data.records || [];
                setExpiringMedicines(medicines);
                
                // Show alert if there are expiring medicines
                if (medicines.length > 0) {
                    setShowExpiryAlert(true);
                }
            }
        } catch (error) {
            console.error("Error fetching expiring medicines:", error);
        }
    };
    const formatBillDate = (dateStr) => {
        if (!dateStr) return '';
        const d = new Date(dateStr);
        if (isNaN(d)) return dateStr;
    
        const day = String(d.getDate()).padStart(2, '0');
        const monthNames = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
        const month = monthNames[d.getMonth()];
        const year = d.getFullYear();
    
        return `${day}-${month}-${year}`;
    };
    
    const formatAge = (y = 0, m = 0, d = 0) => {
        const parts = [];
        if (y > 0) parts.push(`${y} Year${y > 1 ? 's' : ''}`);
        if (m > 0) parts.push(`${m} Month${m > 1 ? 's' : ''}`);
        if (d > 0) parts.push(`${d} Day${d > 1 ? 's' : ''}`);
        return parts.length ? parts.join(' ') : '0 Day';
    };
    
    const generateInvoicePdf = async (invoiceData) => {
    
        const doc = new jsPDF("p", "pt", "a4");
        const pageWidth = doc.internal.pageSize.getWidth();
        const margin = 30;
        let y = 40;
    
        const headerImageBase64 = await imageUrlToBase64(image);
        const headerImageHeight = 80;
    
        if (headerImageBase64) {
            doc.addImage(headerImageBase64, "PNG", 0, 0, pageWidth, headerImageHeight);
        }
    
        y = headerImageHeight + 20;
        doc.setFont("helvetica", "bold");
        doc.setFontSize(16);
        doc.text("Pharmacy Bill", pageWidth / 2, y, { align: "center" });
        y += 10; // Add spacing after header
        doc.rect(margin, y, pageWidth - 2 * margin, 80);
    
        let leftX = margin + 10;
        let rightX = pageWidth / 2 + 40;
        let lineY = y + 15;
    
        doc.setFont("helvetica", "bold");
        doc.setFontSize(10);
        doc.text("Bill To:", leftX, lineY);
    
        doc.setFont("helvetica", "normal");
        doc.setFontSize(9);
    
        doc.text(
            `Patient Name : ${invoiceData.med_bill_patient_number || 'Walk-in Customer'}`,
            leftX,
            (lineY += 15)
        );
    
        const ageText = formatAge(
            invoiceData.med_bill_age_year,
            invoiceData.med_bill_age_month,
            invoiceData.med_bill_age_day
        );
    
        doc.text(`Age : ${ageText}`, leftX, (lineY += 15));
        doc.text(`Mobile : ${invoiceData.med_bill_phone_number || ''}`, leftX, (lineY += 15));
    
        doc.text(
            `Doctor : ${invoiceData.med_bill_doctor || invoiceData.med_bill_ref_doctor || '-'}`,
            leftX,
            (lineY += 15)
        );
    
        lineY = y + 15;
    
        const grandTotal = parseFloat(invoiceData.med_bill_final_amt || 0);
        const paid = parseFloat(invoiceData.med_bill_paid || 0);
    
        let paymentStatus = "Not Paid";
        if (paid >= grandTotal) paymentStatus = "Paid";
        else if (paid > 0) paymentStatus = "Partial Paid";
    
        doc.text(`UHID : ${invoiceData.med_bill_ipd_number || ''}`, rightX, lineY);
doc.text(`Bill No : ${formatBillNo(invoiceData.med_bill_id)}`, rightX, (lineY += 15));
        doc.text(`Bill Date : ${formatBillDate(invoiceData.med_bill_date)}`, rightX, (lineY += 15));
        doc.text(`Payment Status : ${paymentStatus}`, rightX, (lineY += 15));
    
        y += 100;
    
        const tableHeaders = [[
            "Sl#", "Product", "Pack", "Qty", "Batch", "Expiry", "HSN", "Discount", "MRP", "Amount"
        ]];
    
        const tableBody = (invoiceData.items || []).map((med, index) => {
            const qty = parseInt(med.med_bill_item_qty || 0);
            const mrp = parseFloat(med.med_bill_item_mrp || 0);
            const discount = parseFloat(med.med_bill_item_discount || 0);
            const total = (mrp - discount) * qty;
    
            return [
                index + 1,
                med.med_bill_item_medicine || '',
                (med.med_bill_item_is_loose == 1 ? "Loose" : "Package"),
                qty,
                med.med_bill_item_batch || '',
                med.med_bill_item_exp || '',
                med.med_bill_item_hsn || '',
                discount.toFixed(2),
                mrp.toFixed(2),
                total.toFixed(2),
            ];
        });
    
        autoTable(doc, {
            startY: y,
            head: tableHeaders,
            body: tableBody,
            theme: "grid",
            styles: { fontSize: 9, cellPadding: 4 },
            headStyles: { fillColor: [220, 220, 220], textColor: 0, fontStyle: "bold" }
        });
    
        y = doc.lastAutoTable.finalY + 15;
    
        const totalTax = (invoiceData.items || []).reduce(
            (sum, i) => sum + parseFloat(i.med_bill_item_tax_amt || 0),
            0
        );
    
        const subtotal = parseFloat(invoiceData.med_bill_total || 0);
        const discountAll = parseFloat(invoiceData.med_bill_discount_amt || 0);
        const due = parseFloat(invoiceData.med_bill_due || 0);
    
        doc.setFontSize(10);
        doc.text(`Subtotal`, pageWidth - margin - 200, y);
        doc.text(`Rs ${subtotal.toFixed(2)}`, pageWidth - margin, y, { align: "right" });
    
        doc.text(`Total GST`, pageWidth - margin - 200, (y += 15));
        doc.text(`Rs ${totalTax.toFixed(2)}`, pageWidth - margin, y, { align: "right" });
    
        doc.text(`Discount`, pageWidth - margin - 200, (y += 15));
        doc.text(`Rs ${discountAll.toFixed(2)}`, pageWidth - margin, y, { align: "right" });
    
        doc.setFont("helvetica", "bold");
        doc.text(`Grand Total`, pageWidth - margin - 200, (y += 20));
        doc.text(`Rs ${grandTotal.toFixed(2)}`, pageWidth - margin, y, { align: "right" });
    
        doc.setFont("helvetica", "normal");
        doc.text(`Paid`, pageWidth - margin - 200, (y += 15));
        doc.text(`Rs ${paid.toFixed(2)}`, pageWidth - margin, y, { align: "right" });
    
        doc.text(`Due`, pageWidth - margin - 200, (y += 15));
        doc.text(`Rs ${due.toFixed(2)}`, pageWidth - margin, y, { align: "right" });
    
        y += 30;
        doc.text(`Amount in Words: ${numberToWords(grandTotal)}`, margin, y);
        y += 25;
        doc.setFont("helvetica", "bold");
        doc.text("Authorised Signature", pageWidth - margin, y, { align: "right" });
        
        window.open(doc.output("bloburl"), "_blank");
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        
        const fd = new FormData();
    
        fd.append('med_bill_id', formData.med_bill_id);
        fd.append('med_bill_date', formData.med_bill_date);
        fd.append('med_bill_type', formData.lab_reg_type || 'Direct');
        fd.append('lab_reg_age_year', formData.lab_reg_age_year || 0);
        fd.append('lab_reg_age_month', formData.lab_reg_age_month || 0);
        fd.append('lab_reg_age_day', formData.lab_reg_age_day || 0);

        fd.append('med_bill_ipd_number', formData.med_bill_ipd_number);
        fd.append('med_bill_patient_number', formData.med_bill_patient_number);
        fd.append('med_bill_doctor', formData.lab_consult_doctor || formData.med_bill_doctor);
        fd.append('med_bill_ref_doctor', formData.med_bill_ref_doctor);
        fd.append('med_bill_phone_number', formData.med_bill_phone_number);
        fd.append('med_bill_address_of_patient', formData.med_bill_address_of_patient);
        fd.append('med_bill_gst_number', formData.med_bill_gst_number);
        fd.append('med_bill_drug_licence_no', formData.med_bill_drug_licence_no);
        fd.append('med_bill_discount', formData.discount_percent || '0');
        fd.append('med_bill_discount_amt', formData.discount_on_all_amt || '0');
        fd.append('med_bill_mode_of_payment', formData.med_bill_payment_mode);
        fd.append('med_bill_total', formData.subtotal);
        fd.append('med_bill_final_amt', formData.grand_total);
        fd.append('med_bill_paid', formData.med_bill_paid || '0');
        fd.append('med_bill_payment_mode', formData.med_bill_payment_mode || 'cash');
        fd.append('med_bill_remarks', formData.med_bill_remarks || '');
        fd.append('med_bill_due', (parseFloat(formData.grand_total || 0) - parseFloat(formData.med_bill_paid || 0)).toFixed(2));
        fd.append('med_items', JSON.stringify(formData.medicines));
        fd.append('med_bill_user', ldata.user_id);
    
        try {
            const response = await axios.post(AppConst.BASE_URL + AppConst.addMedBillUrl, fd, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            });
    
            if (response.data.status) {
                const billData = response.data.med_bill_dt;
                const generatedUHID = response.data.generated_uhid || billData.med_bill_ipd_number || formData.med_bill_ipd_number;
                
                const invoiceData = {
                    ...billData,
                    items: formData.medicines.filter(m => m.med_bill_item_medicine),
                    med_bill_id: billData.med_bill_id,
                    med_bill_ipd_number: generatedUHID,
                    med_bill_patient_number: formData.med_bill_patient_number,
                    med_bill_phone_number: formData.med_bill_phone_number,
                    med_bill_doctor: formData.lab_consult_doctor,
                    med_bill_ref_doctor: formData.med_bill_ref_doctor,
                    med_bill_address_of_patient: formData.med_bill_address_of_patient,
                    med_bill_discount_amt: formData.discount_on_all_amt,
                    med_bill_total: formData.subtotal,
                    med_bill_final_amt: formData.grand_total,
                    med_bill_paid: formData.med_bill_paid,
                    med_bill_payment_mode: formData.med_bill_payment_mode,
                    med_bill_due: (parseFloat(formData.grand_total || 0) - parseFloat(formData.med_bill_paid || 0)).toFixed(2),
                    med_bill_date: formData.med_bill_date,
                    med_bill_age_year: formData.lab_reg_age_year,
                    med_bill_age_month: formData.lab_reg_age_month,
                    med_bill_age_day: formData.lab_reg_age_day,
                };
    
                Swal.fire({
                    title: 'Success!',
                    html: `
                        <p><strong>Sale Created Successfully!</strong></p>
                        ${generatedUHID ? `<p><strong>UHID:</strong> <span style="color: #0d6efd; font-size: 18px;">${generatedUHID}</span></p>` : ''}
                    `,
                    icon: 'success',
                    showCancelButton: true,
                    showDenyButton: true,
                    confirmButtonColor: '#0d6efd',
                    denyButtonColor: '#6c757d',
                    cancelButtonColor: '#198754',
                    confirmButtonText: '<i class="ri-printer-fill me-1"></i> Print Invoice',
                    denyButtonText: 'Close',
                    cancelButtonText: 'Go to Sales'
                }).then((result) => {
                    if (result.isConfirmed) {
                        generateInvoicePdf(invoiceData);
                        
                        setTimeout(() => {
                            sessionStorage.removeItem("opd_dt");
                            window.location.href = "/sales";
                        }, 500);
                        
                    } else if (result.dismiss === Swal.DismissReason.cancel) {
                        sessionStorage.removeItem("opd_dt");
                        window.location.href = "/sales";
                        
                    }
                });
            }
            else {
                Swal.fire('Error', response.data.success || 'Failed to create sale', 'error');
            }
        } catch (error) {
            console.error(error);
            Swal.fire('Error', 'Failed to create sale', 'error');
        }
    };

    const initData = async () => {
        const storedData = sessionStorage.getItem("ldata");
        if (storedData) {
            const parsed = JSON.parse(storedData);
            var fd = new FormData();
            fd.append('page_no', "0");
            fd.append('search_key', formData.search_key + "");
            try {
                const response = await axios.post(AppConst.BASE_URL + AppConst.getTestListUrl, fd, {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                    },
                });
                if (response.data.status) {

                    var records = response.data.records;
                    if (records != null && records != undefined) {
                        setFormData(prev => ({
                            ...prev,
                            tests: records
                        }));
                        if (formData.items.length <= 0) {
                            setFormData(prev => ({
                                ...prev,
                                items: records
                            }));
                        }
                    }
                }
            } catch (error) {

            }

            const fd2 = new FormData();
            fd2.append('type', "doctor");
            fd2.append('search_key', " ");
            fd2.append('page_no', "none");
            try {
                const response = await axios.post(AppConst.BASE_URL + AppConst.getUserListUrl, fd2, {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                    },
                });
                if (response.data.status) {

                    var records = response.data.records;
                    if (records != null && records != undefined) {
                        setFormData(prev => ({
                            ...prev,
                            docs: records
                        }));
                    }
                }
            } catch (error) {

            }

            fd = new FormData();
            fd.append('cat_type', "vital");
            fd.append('page_no', "none");
            fd.append('search_key', "");
            fd.append('par_by', 1 + "");
            try {
                const response = await axios.post(AppConst.BASE_URL + AppConst.getCatListUrl, fd, {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                    },
                });
                if (response.data.status) {

                    var records = response.data.records;
                    if (records != null && records != undefined) {
                        setFormData(prev => ({
                            ...prev,
                            vitals: records
                        }));
                    }
                }
            } catch (error) {

            }
        }
    };

    const initData3 = async () => {
        const storedData = sessionStorage.getItem("ldata");
        if (!storedData) {
            console.error("No ldata found in sessionStorage");
            return;
        }
    
        try {
            const parsed = JSON.parse(storedData);
            const fd = new FormData();
            fd.append('page_no', formData.page_no + "");
            fd.append('search_key', formData.search_key + "");
            fd.append('purchase_type', "normal");
    
            const response = await axios.post(
                AppConst.BASE_URL + AppConst.getPurchaseListUrl, 
                fd,
                {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                    },
                }
            );
    
            if (response.data.status) {
                const records = response.data.records;
                
                if (!records || !Array.isArray(records)) {
                    console.warn("No records found or invalid format");
                    setFormData((prev) => ({
                        ...prev,
                        medicineList: [],
                    }));
                    return;
                }
    
                let allMedicines = [];
    
                records.forEach((rec) => {
                    if (rec.items && Array.isArray(rec.items)) {
                        allMedicines = [...allMedicines, ...rec.items];
                    }
                });
    
                setFormData((prev) => ({
                    ...prev,
                    medicineList: allMedicines,
                }));
    
            } else {
                console.error("API returned status false:", response.data);
                toast.error(response.data.message || "Failed to load medicines");
                
                setFormData((prev) => ({
                    ...prev,
                    medicineList: [],
                }));
            }
    
        } catch (error) {
            console.error("Error in initData3:", error);
            
            if (error.response) {
                console.error("Server Error Response:", {
                    status: error.response.status,
                    data: error.response.data,
                    headers: error.response.headers
                });
                toast.error(`Server Error: ${error.response.status} - ${error.response.data?.message || 'Unknown error'}`);
            } else if (error.request) {
                console.error("No response received:", error.request);
                toast.error("Network error: No response from server");
            } else {
                console.error("Request setup error:", error.message);
                toast.error(`Error: ${error.message}`);
            }
    
            setFormData((prev) => ({
                ...prev,
                medicineList: [],
            }));
        }
    };

    useEffect(() => {
        if (!formData.medicines.length || !formData.medicineList.length) return;
    
        setFormData(prev => {
            const updated = prev.medicines.map(item => {
                if (!item.med_bill_item_medicine) return item;
    
                const batches = prev.medicineList.filter(
                    m => m.purchase_item_medicine === item.med_bill_item_medicine
                );
    
                const selectedBatch = batches.find(
                    b => b.purchase_item_batch === item.med_bill_item_batch
                );
    
                if (!selectedBatch) return item;
    
                const expMonthName = selectedBatch.purchase_item_expiry_month
                    ? monthNames[parseInt(selectedBatch.purchase_item_expiry_month) - 1]
                    : "";
    
                return {
                    ...item,
                    available_batches: batches,
                    package_stock: selectedBatch.purchase_item_qty_stock || 0,
                    loose_stock: selectedBatch.purchase_item_tab_cap_stock || 0,
                    loose_per_package: selectedBatch.purchase_item_tab_cap || 1,
                    med_bill_item_exp: expMonthName
                        ? `${expMonthName}-${selectedBatch.purchase_item_expiry_year}`
                        : item.med_bill_item_exp
                };
            });
    
            return { ...prev, medicines: updated };
        });
    }, [formData.medicineList]);
    
    useEffect(() => {
        console.log('Component mounted');
        const storedData = sessionStorage.getItem("ldata");
        if (storedData) {
            const parsed = JSON.parse(storedData);
            setLdata(parsed);
            initData();
            initData3();
            fetchConfigData();
            loadDoctors();
            fetchExpiringMedicines();
        }
    
        if (
            sessionStorage.getItem("opd_dt") != null &&
            sessionStorage.getItem("opd_dt") != undefined &&
            sessionStorage.getItem("opd_dt").length > 0
        ) {
            var tmp = JSON.parse(sessionStorage.getItem("opd_dt") + "");
            if (tmp != null && tmp != undefined) {
    
                const medicines = tmp.items && tmp.items.length > 0 
                    ? tmp.items.map((item, index) => ({
                        sn: index + 1,
                        med_bill_item_medicine: item.med_bill_item_medicine || '',
                        med_bill_item_batch: item.med_bill_item_batch || '',
                        med_bill_item_qty: item.med_bill_item_qty || '1',
                        med_bill_item_strips: item.med_bill_item_strips || '',
                        med_bill_item_is_loose: item.med_bill_item_is_loose || '0',
                        med_bill_item_exp: item.med_bill_item_exp || '',
                        med_bill_item_mrp: item.med_bill_item_mrp || '',
                        med_bill_item_discount: item.med_bill_item_discount || '0',
                        med_bill_item_discount_amt: item.med_bill_item_discount_amt || '0',
                        med_bill_item_tax: item.med_bill_item_tax || '0',
                        med_bill_item_tax_amt: item.med_bill_item_tax_amt || '0',
                        med_bill_item_total: item.med_bill_item_total || '',
                        package_stock: item.med_bill_item_strips || 0,
                        loose_stock: item.med_bill_item_strips || 0,
                        original_mrp: item.med_bill_item_mrp || '',
                        loose_per_package: 0,
                        available_batches: [],
                    }))
                    : [{
                        sn: 1,
                        med_bill_item_medicine: '',
                        med_bill_item_batch: '',
                        med_bill_item_qty: '',
                        med_bill_item_strips: '',
                        med_bill_item_is_loose: '',
                        med_bill_item_exp: '',
                        med_bill_item_mrp: '',
                        med_bill_item_discount: '',
                        med_bill_item_discount_amt: '',
                        med_bill_item_tax: '',
                        med_bill_item_tax_amt: '',
                        med_bill_item_total: '',
                    }];
    
                setFormData(prev => ({
                    ...prev,
                    medicines: medicines,
                    med_bill_id: tmp.med_bill_id || '',
                    med_bill_date: tmp.med_bill_date || '',
                    med_bill_type: tmp.med_bill_type || 'normal',
                    lab_reg_type: tmp.med_bill_type || 'Direct',
                    med_bill_ipd_number: tmp.med_bill_ipd_number || '',
                    med_bill_patient_number: tmp.med_bill_patient_number || '',
                    med_bill_doctor: tmp.med_bill_doctor || '',
                    lab_consult_doctor: tmp.med_bill_doctor || '',
                    med_bill_ref_doctor: tmp.med_bill_ref_doctor || '',
                    med_bill_phone_number: tmp.med_bill_phone_number || '',
                    med_bill_address_of_patient: tmp.med_bill_address_of_patient || '',
                    med_bill_gst_number: tmp.med_bill_gst_number || '',
                    med_bill_drug_licence_no: tmp.med_bill_drug_licence_no || '',
                    discount_percent: tmp.med_bill_discount || '0',
                    discount_on_all_amt: tmp.med_bill_discount_amt || '0',
                    med_bill_mode_of_payment: tmp.med_bill_mode_of_payment || '',
                    subtotal: tmp.med_bill_total || '0',
                    grand_total: tmp.med_bill_final_amt || '0',
                    med_bill_paid: tmp.med_bill_paid || '0',
                    med_bill_payment_mode: tmp.med_bill_payment_mode || 'cash',
                    med_bill_remarks: tmp.med_bill_remarks || '',
                    med_bill_due: tmp.med_bill_due || '0',
                    med_bill_user: tmp.med_bill_user || '',
                    med_bill_datetime: tmp.med_bill_datetime || '',
                    
                    lab_reg_age_year:  tmp.med_bill_age_year  || '',
                    lab_reg_age_month: tmp.med_bill_age_month || '',
                    lab_reg_age_day:   tmp.med_bill_age_day   || '',
                    
                    lab_reg_name_title: tmp.lab_reg_name_title || 'Mr.',
                    lab_reg_gender: tmp.lab_reg_gender || 'Male',
                }));
    
                setOriginalLabRegType(tmp.med_bill_type || 'Direct');
                setIsUHIDReadOnly(true);
            }
        }
    
        return () => {
            console.log('Component unmounted');
        };
    }, []);

    useEffect(() => {
      setFormData(prev => {
        const medicines = prev.medicines.map(item => {
          const mrp = parseFloat(item.med_bill_item_mrp) || 0;
          const qty = parseInt(item.med_bill_item_qty) || 0;
          const discount = parseFloat(item.med_bill_item_discount) || 0;
          const taxRate = parseFloat(item.med_bill_item_tax) || 0;
    
          const base = mrp * qty;
          const afterDiscount = base - discount;
          const taxAmt = (afterDiscount * taxRate) / 100;
          const total = afterDiscount;
    
          return {
            ...item,
            med_bill_item_tax_amt: taxAmt.toFixed(2),
            med_bill_item_total: total.toFixed(2),
          };
        });
    
        return { ...prev, medicines };
      });
    }, [formData.medicines.map(m => (
      `${m.med_bill_item_qty}-${m.med_bill_item_discount}-${m.med_bill_item_tax}-${m.med_bill_item_mrp}`
    )).join('|')]);

    const handleAutoGenderChange = (e) => {
        const { name, value } = e.target;

        let genderValue = "";

        if (value === "Mr." || value === "Master") {
            genderValue = "Male";
        } else if (value === "Mr's" || value === "Miss") {
            genderValue = "Female";
        } else {
            genderValue = "Other";
        }

        setFormData((prev) => ({
            ...prev,
            lab_reg_name_title: value,
            lab_reg_gender: genderValue
        }));
    };

    useEffect(() => {
        const today = new Date();
        const formatted = today.toISOString().split('T')[0];
        setFormData(prev => ({
            ...prev,
            med_bill_date: formatted
        }));
    }, []);

    const searchUserNow = async () => {
        const uhid = (formData.med_bill_ipd_number || "").trim();
    
        if (uhid.length <= 7) {
            toast.error("Please enter a valid UHID");
            return;
        }
    
        try {
            const fd = new FormData();
            fd.append('lab_reg_uhid', uhid);
    
            const response = await axios.post(
                AppConst.BASE_URL + AppConst.searchUhidUrlCall, 
                fd,
                { headers: { 'Content-Type': 'multipart/form-data' } }
            );
    
            if (response.data.status) {
                const users = response.data.records;
                if (users && users.length > 0) {
                    const patient = users[0];
                    
                    setFormData(prev => ({
                        ...prev,
                        lab_reg_name_title: patient.lab_reg_name_title || "",
                        med_bill_patient_number: patient.lab_reg_name || "",
                        lab_reg_gender: patient.lab_reg_gender || "Male",
                        med_bill_address_of_patient: patient.lab_reg_address || "",
                        lab_reg_city: patient.lab_reg_city || "",
                        lab_reg_state: patient.lab_reg_state || "",
                        med_bill_phone_number: patient.lab_reg_mobile || "",
                        med_bill_type: patient.lab_reg_type || "normal",
                        lab_reg_age_year: patient.lab_reg_age_year || '',
                        lab_reg_age_month: patient.lab_reg_age_month || '',
                        lab_reg_age_day: patient.lab_reg_age_day || '',
                        med_bill_ref_doctor: patient.lab_reg_referral || '',
                        med_bill_ipd_number: patient.lab_reg_uhid || "",
                        lab_reg_type: patient.lab_reg_type || "",
                    }));

                    toast.success("Patient details loaded");
                } else {
                    toast.error("No patient found with this UHID");
                }
            } else {
                toast.error(response.data.message || "No patient found");
            }
        } catch (error) {
            console.error("Search Error:", error);
            toast.error("Error fetching patient details");
        }
    };

    // ✅ UPDATED - Handle Batch Change with Stock Validation
    const handleBatchChange = (e, index) => {
        const selectedBatchNumber = e.target.value;
        const medicines = [...formData.medicines];
        const currentItem = { ...medicines[index] };

        const newBatchData = currentItem.available_batches.find(
            (b) => b.purchase_item_batch === selectedBatchNumber
        );

        if (newBatchData) {
            const pkgStock = parseInt(newBatchData.purchase_item_qty_stock || 0);
            const looseStock = parseInt(newBatchData.purchase_item_tab_cap_stock || 0);

            const stockToCheck = currentItem.med_bill_item_is_loose === "1" ? looseStock : pkgStock;

            if (stockToCheck <= 0) {
                Swal.fire({
                    icon: "error",
                    title: "Out of Stock!",
                    text: `Batch ${selectedBatchNumber} is out of stock. Please select a different batch.`,
                    confirmButtonColor: '#dc3545'
                });
                return;
            }

            const expMonthName = newBatchData.purchase_item_expiry_month
                ? monthNames[parseInt(newBatchData.purchase_item_expiry_month) - 1]
                : "";
            
            currentItem.med_bill_item_batch = newBatchData.purchase_item_batch;
            currentItem.med_bill_item_exp = expMonthName
                ? `${expMonthName}-${newBatchData.purchase_item_expiry_year}`
                : "N/A";
            
            currentItem.purchase_item_expiry_month = newBatchData.purchase_item_expiry_month;
            currentItem.purchase_item_expiry_year = newBatchData.purchase_item_expiry_year;

            currentItem.med_bill_item_mrp = newBatchData.purchase_item_mrp;
            currentItem.original_mrp = newBatchData.purchase_item_mrp;
            
            currentItem.package_stock = pkgStock;
            currentItem.loose_stock = looseStock;
            currentItem.loose_per_package = parseInt(newBatchData.purchase_item_tab_cap) || 15;
            
            if (currentItem.med_bill_item_is_loose === "1") {
                currentItem.med_bill_item_strips = looseStock;
            } else {
                currentItem.med_bill_item_strips = pkgStock;
            }
            
            currentItem.med_bill_item_qty = '1';
            
            medicines[index] = currentItem;
            setFormData(prev => ({ ...prev, medicines }));
        }
    };
    const isBatchExpired = (expMonth, expYear) => {
        if (!expMonth || !expYear) return false;
    
        // Expiry is END of expiry month
        const expiryDate = new Date(
            2000 + parseInt(expYear), // YY → YYYY
            parseInt(expMonth),       // next month
            0                          // last day of expiry month
        );
    
        const today = new Date();
        today.setHours(0, 0, 0, 0);
    
        return expiryDate < today;
    };
    
    // ✅ UPDATED - Handle Unit Change with Stock Validation
    const handleUnitChange = (e, index) => {
        const { value } = e.target;
        const medicines = [...formData.medicines];
        const currentItem = { ...medicines[index] };

        currentItem.med_bill_item_is_loose = value;
        currentItem.med_bill_item_qty = '1';

        if (value === "1") {
            if (currentItem.loose_stock <= 0) {
                Swal.fire({
                    icon: "warning",
                    title: "No Loose Stock!",
                    text: `This batch has no loose stock available. Only ${currentItem.package_stock} packages are available.`,
                    confirmButtonColor: '#ffc107'
                });
                return;
            }

            currentItem.med_bill_item_mrp = (currentItem.original_mrp / currentItem.loose_per_package).toFixed(2);
            currentItem.med_bill_item_strips = currentItem.loose_stock;
        } else {
            if (currentItem.package_stock <= 0) {
                Swal.fire({
                    icon: "warning",
                    title: "No Package Stock!",
                    text: `This batch has no package stock available. Only ${currentItem.loose_stock} loose units are available.`,
                    confirmButtonColor: '#ffc107'
                });
                return;
            }

            currentItem.med_bill_item_mrp = currentItem.original_mrp;
            currentItem.med_bill_item_strips = currentItem.package_stock;
        }

        medicines[index] = currentItem;
        setFormData(prev => ({ ...prev, medicines }));
    };

    // ✅ UPDATED - Handle Medicine Select with Better Stock Check
    const handleMedicineSelect = (medicine) => {
        const allBatchesForMedicine = formData.medicineList.filter(
            (item) => item.purchase_item_medicine === medicine.purchase_item_medicine
        );

        const pkgStock = parseInt(medicine.purchase_item_qty_stock || 0);
        const looseStock = parseInt(medicine.purchase_item_tab_cap_stock || 0);

        if (pkgStock <= 0 && looseStock <= 0) {
            Swal.fire({
                icon: "error",
                title: "Out of Stock!",
                text: `Batch ${medicine.purchase_item_batch} is completely out of stock.`,
                confirmButtonColor: '#dc3545'
            });
            return;
        }

        const expMonthName = medicine.purchase_item_expiry_month 
            ? monthNames[parseInt(medicine.purchase_item_expiry_month) - 1] 
            : "";

        const newItem = {
            sn: formData.medicines.length + 1,
            med_bill_item_medicine: medicine.purchase_item_medicine,
            med_bill_item_batch: medicine.purchase_item_batch,
            med_bill_item_hsn: medicine.purchase_item_hsn || '0', 
            med_bill_item_qty: '1',
            med_bill_item_is_loose: pkgStock > 0 ? "0" : "1",
            
            med_bill_item_exp: expMonthName 
                ? `${expMonthName}-${medicine.purchase_item_expiry_year}`
                : "",

            purchase_item_expiry_month: medicine.purchase_item_expiry_month,
            purchase_item_expiry_year: medicine.purchase_item_expiry_year,

            med_bill_item_mrp: pkgStock > 0 ? medicine.purchase_item_mrp : (medicine.purchase_item_mrp / (parseInt(medicine.purchase_item_tab_cap) || 15)).toFixed(2),
            med_bill_item_discount: '0',
            med_bill_item_tax: medicine.purchase_item_gst || '0.00',
            med_bill_item_tax_amt: medicine.purchase_item_gst_value || '0.00',
            med_bill_item_total: '',
            
            package_stock: pkgStock,
            loose_stock: looseStock,
            
            med_bill_item_strips: pkgStock > 0 ? pkgStock : looseStock,
            
            available_batches: allBatchesForMedicine,
            original_mrp: medicine.purchase_item_mrp,
            loose_per_package: parseInt(medicine.purchase_item_tab_cap) || 15,
        };

        setFormData((prev) => ({
            ...prev,
            medicines: [...prev.medicines.filter(m => m.med_bill_item_medicine), newItem],
        }));

        setMedicineSearch("");
        setShowMedicineOptions(false);

        if (pkgStock <= 0 && looseStock > 0) {
            toast.info("Only loose stock available for this batch", { autoClose: 2000 });
        } else if (looseStock <= 0 && pkgStock > 0) {
            toast.info("Only package stock available for this batch", { autoClose: 2000 });
        }
    };

    useEffect(() => {
        let subtotal = 0;
        let totalGST = 0;
        let totalDiscount = 0;
        let totalqty = 0;
    
        formData.medicines.forEach((item) => {
            const mrp = parseFloat(item.med_bill_item_mrp) || 0;
            const qty = parseInt(item.med_bill_item_qty) || 0;
            const discount = parseFloat(item.med_bill_item_discount) || 0;
            const taxRate = parseFloat(item.med_bill_item_tax) || 0;
    
            const rowSubtotal = (mrp - discount) * qty;
            const rowTax = (rowSubtotal * taxRate) / 100;
    
            subtotal += rowSubtotal;
            totalDiscount += discount;
            totalGST += rowTax;
            totalqty += qty;
        });
    
        const discountOnAll = ((subtotal || 0) * (formData.discount_percent || 0)) / 100;
        
        // Calculate total before rounding
        const totalBeforeRounding =
            subtotal +
            (parseFloat(formData.other_charges) || 0) -
            totalDiscount -
            discountOnAll;
    
        // ✅ AUTO ROUND-OFF LOGIC
        let roundOff = 0;
        let grandTotal = totalBeforeRounding;
    
        // Get the decimal part
        const decimalPart = totalBeforeRounding - Math.floor(totalBeforeRounding);
    
        if (decimalPart > 0) {
            if (decimalPart > 0.30) {
                // Round UP - add remaining amount to reach next rupee
                roundOff = 1 - decimalPart;
                grandTotal = Math.ceil(totalBeforeRounding);
            } else {
                // Round DOWN - subtract decimal part
                roundOff = -decimalPart;
                grandTotal = Math.floor(totalBeforeRounding);
            }
        }
    
        setFormData((prev) => ({
            ...prev,
            subtotal: subtotal.toFixed(2),
            total_gst: totalGST.toFixed(2),
            discount_on_all_amt: discountOnAll.toFixed(2),
            round_off: roundOff.toFixed(2),
            grand_total: grandTotal.toFixed(2),
            total_qty: totalqty,
        }));
    }, [formData.medicines, formData.discount_percent, formData.other_charges]);
    useEffect(() => {
        function handleClickOutside(event) {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setShowMedicineOptions(false);
            }
        }

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [setShowMedicineOptions]);

    return (
        <div className="page-content">
            <div className="container-fluid">
                <div className="row">
                    <div className="col-xxl-12">
                        <div className="card">
                            <div className="card-body">
                                <h5>Pharmacy Sale</h5>
                                <br />
                                <div className="live-preview">
                                    <form onSubmit={handleSubmit}>
                                        <div className="card">
                                            <div className="card-body">
                                                <div className="row">
                                                    <div className="col-lg-12">
                                                        <h5 style={{color:"#405189"}}>Patient Details</h5>
                                                        <br />
                                                    </div>
                                                    <div className="col-md-2">
                                                        <div className="mb-4">
                                                            <label htmlFor="firstNameinput" className="form-label">Patient Type</label>
                                                            <select className="form-control" name="lab_reg_type" onChange={handleChange} value={formData.lab_reg_type} required>
                                                                <option value="Direct" selected>Direct</option>
                                                                <option value="OPD">OPD</option>
                                                                <option value="IPD">IPD</option>
                                                            </select>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-2">
                                                        <div className="mb-3">
                                                            <label htmlFor="uhidInput" className="form-label">UHID</label>
                                                            <input
                                                                type="text"
                                                                id="uhidInput"
                                                                className="form-control"
                                                                placeholder="Enter UHID"
                                                                name="med_bill_ipd_number"
                                                                onChange={handleChange}
                                                                value={formData.med_bill_ipd_number}
                                                                readOnly={isUHIDReadOnly}
                                                                style={{
                                                                    backgroundColor: isUHIDReadOnly ? '#e9ecef' : 'white'
                                                                }}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="col-md-2">
                                                        <button id="pop45" style={{ display: "none" }}
                                                            type="button" className="btn btn-success add-btn px-0"
                                                            data-bs-toggle="modal" data-bs-target="#usrModel"></button>
                                                        <button id="searchbtn" onClick={() => {
                                                            searchUserNow()
                                                        }} type="button" className="btn btn-success mt-4 " style={{width: "150px"}}>
                                                            <i className="ri-search-line align-bottom me-1"></i> Search </button>
                                                    </div>
                                                    <div className="col-md-6">
                                                        <div className="mb-3">
                                                            <label htmlFor="firstNameinput" className="form-label">Age</label>
                                                            <div className="row">
                                                                <div className="col-md-4">
                                                                    <input type="number" className="form-control" placeholder="Year" name="lab_reg_age_year" onChange={handleChange} value={formData.lab_reg_age_year} required />
                                                                </div>
                                                                <div className="col-md-4">
                                                                    <input type="number" className="form-control" placeholder="Month" name="lab_reg_age_month" onChange={handleChange} value={formData.lab_reg_age_month} />
                                                                </div>
                                                                <div className="col-md-4">
                                                                    <input type="number" className="form-control" placeholder="Day" name="lab_reg_age_day" onChange={handleChange} value={formData.lab_reg_age_day} />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className="col-md-6">
                                                        <div className="row">
                                                            <div className="col-md-12">
                                                                <div >
                                                                    <label htmlFor="productname-field" className="form-label">Patient Name</label>
                                                                    <div className="row">
  
                                                                        <div className="col-md-3">
                                                                            <select className="form-control"
                                                                                name="lab_reg_name_title"
                                                                                onChange={handleAutoGenderChange}
                                                                                value={formData.lab_reg_name_title}
                                                                                required>
                                                                                <option value="Mr.">Mr.</option>
                                                                                <option value="Mr's">Mr's</option>
                                                                                <option value="Miss">Miss</option>
                                                                                <option value="Master">Master</option>
                                                                                <option value="Other">Other</option>
                                                                            </select>
                                                                        </div>

                                                                        <div className="col-md-6">
                                                                            <input
                                                                                type="text"
                                                                                className="form-control"
                                                                                placeholder="Enter Name"
                                                                                name="med_bill_patient_number"
                                                                                onChange={handleChange}
                                                                                value={formData.med_bill_patient_number}
                                                                                required
                                                                            />
                                                                        </div>

                                                                        <div className="col-md-3">
                                                                            <select
                                                                                className="form-control"
                                                                                name="lab_reg_gender"
                                                                                value={formData.lab_reg_gender}
                                                                                disabled
                                                                                required>
                                                                                <option value="Male">Male</option>
                                                                                <option value="Female">Female</option>
                                                                                <option value="Other">Other</option>
                                                                            </select>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="col-md-12"><br /></div>
                                                            <div className="col-md-6">
                                                                <div className="mb-3">
                                                                    <label htmlFor="firstNameinput" className="form-label">Mobile Number</label>
                                                                    <input type="text" className="form-control" placeholder="Enter Mobile Number" name="med_bill_phone_number" onChange={handleChange} value={formData.med_bill_phone_number} required />
                                                                </div>
                                                            </div>
  
                                                            <div className="col-md-6">
                                                                <div className="mb-3">
                                                                    <label className="form-label">Referred Doctor</label>
                                                                    <Select
                                                                        placeholder="Select Referred Doctor"
                                                                        options={formData.docs.map(doc => ({
                                                                            value: doc.fname,
                                                                            label: doc.fname
                                                                        }))}
                                                                        value={
                                                                            formData.med_bill_ref_doctor
                                                                            ? { value: formData.med_bill_ref_doctor, label: formData.med_bill_ref_doctor }
                                                                            : null
                                                                        }
                                                                        onChange={(selected) => {
                                                                            setFormData(prev => ({
                                                                            ...prev,
                                                                            med_bill_ref_doctor: selected ? selected.value : ""
                                                                            }));
                                                                        }}
                                                                        isClearable
                                                                    />
                                                                </div>
                                                            </div>

                                                        </div>
                                                    </div>

                                                    <div className="col-md-6">
                                                        <div className="row">
                                                            <div className="col-md-12">
                                                                <div className="mb-3">
                                                                    <label htmlFor="firstNameinput" className="form-label">Address</label>
                                                                    <input type="text" className="form-control"
                                                                        placeholder="Enter Address" name="med_bill_address_of_patient" onChange={handleChange} value={formData.med_bill_address_of_patient} required />
                                                                </div>
                                                            </div>
                                                            
                                                            <div className="col-md-6" >
                                                                <div >
                                                                    <label htmlFor="customername-field" className="form-label">Others Doctor</label>
                                                                    <div className="position-relative" ref={otDocRef}>
                                                                        <input
                                                                            type="text"
                                                                            className="form-control"
                                                                            placeholder="Search Doctor"
                                                                            value={formData.lab_consult_doctor || ""}
                                                                            onChange={(e) => {
                                                                                const value = e.target.value;
                                                                                setFormData((prev) => ({
                                                                                    ...prev,
                                                                                    lab_consult_doctor: value,
                                                                                }));
                                                                            }}
                                                                            onKeyDown={(e) => {
                                                                                if (e.key === "Backspace" && formData.lab_consult_doctor) {
                                                                                    e.preventDefault();
                                                                                    setFormData((prev) => ({
                                                                                        ...prev,
                                                                                        lab_consult_doctor: "",
                                                                                    }));
                                                                                }
                                                                            }}
                                                                            onFocus={() => setShowReferralDropdown(true)}
                                                                            onBlur={() => setTimeout(() => setShowReferralDropdown(false), 200)}
                                                                        />

                                                                        {showReferralDropdown && (
                                                                            <ul
                                                                                className="list-group position-absolute w-100"
                                                                                style={{ maxHeight: "150px", overflowY: "auto", zIndex: 1000 }}
                                                                            >
                                                                                {formData.docs
                                                                                    .filter((doc) =>
                                                                                        formData.lab_consult_doctor
                                                                                            ? doc.fname.toLowerCase().includes(formData.lab_consult_doctor.toLowerCase())
                                                                                            : true
                                                                                    )
                                                                                    .map((doc, index) => (
                                                                                        <li
                                                                                            key={index}
                                                                                            className="list-group-item list-group-item-action"
                                                                                            onMouseDown={() => {
                                                                                                setFormData((prev) => ({
                                                                                                    ...prev,
                                                                                                    lab_consult_doctor: doc.fname,
                                                                                                }));
                                                                                                setShowReferralDropdown(false);
                                                                                            }}
                                                                                            style={{ cursor: "pointer" }}
                                                                                        >
                                                                                            {doc.fname}
                                                                                        </li>
                                                                                    ))}
                                                                                {formData.docs.filter((doc) =>
                                                                                    formData.lab_consult_doctor
                                                                                        ? doc.fname.toLowerCase().includes(formData.lab_consult_doctor.toLowerCase())
                                                                                        : true
                                                                                ).length === 0 && (
                                                                                    <li className="list-group-item text-muted">No doctor found</li>
                                                                                )}
                                                                            </ul>
                                                                        )}
                                                                    </div>
                                                                </div>
                                                            </div>
                              
                                                            <div className="col-md-6">
                                                                <div className="mb-3">
                                                                    <label htmlFor="firstNameinput" className="form-label">Sale Date</label>
                                                                    <input type="date" className="form-control" placeholder="Enter Id"
                                                                        name="med_bill_date" onChange={handleChange} value={formData.med_bill_date} required readOnly />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                
                  
                                        <div className="row">
                                            <div className="col-lg-12">
                                                <br/>
                                                <div className="row mb-3">
                                                    <div className="col-2"></div>
                                                    <div className="col-xxl-8 col-sm-8" ref={dropdownRef}>
                                                        <div className="custom-search-box d-flex align-items-center">
                                                            <span className="search-icon-box">
                                                                <i className="ri-barcode-line"></i>
                                                            </span>

                                                            <div style={{ position: "relative", width: "100%" }}>
                                                                <input
                                                                    type="text"
                                                                    className="form-control custom-search-input"
                                                                    placeholder="Item name/Barcode/Itemcode"
                                                                    value={medicineSearch}
                                                                    onFocus={() => setShowMedicineOptions(true)}
                                                                    onChange={(e) => {
                                                                        setMedicineSearch(e.target.value);
                                                                        setShowMedicineOptions(true);
                                                                    }}
                                                                />
                                                            </div>
                                                        </div>
                                                        {/* ✅ UPDATED MEDICINE DROPDOWN */}
                                                        {showMedicineOptions && (
                                                            <div className="dropdown-menu show w-100" style={{ maxHeight: '400px', overflowY: 'auto' }}>
                                                                {formData.medicineList && formData.medicineList.length > 0 ? (
                                                                    (() => {
                                                                        const medicineGroups = formData.medicineList
                                                                            .filter(m =>
                                                                                m.purchase_item_medicine.toLowerCase().includes(medicineSearch.toLowerCase()) ||
                                                                                m.purchase_item_batch?.toLowerCase().includes(medicineSearch.toLowerCase()) ||
                                                                                m.purchase_item_mrp?.toString().includes(medicineSearch)
                                                                            )
                                                                            .reduce((acc, m) => {
                                                                                if (!acc[m.purchase_item_medicine]) {
                                                                                    acc[m.purchase_item_medicine] = {
                                                                                        ...m,
                                                                                        batches: [],
                                                                                        total_stock: 0
                                                                                    };
                                                                                }
                                                                                
                                                                                const batchStock = parseInt(m.purchase_item_qty_stock || 0);
                                                                                acc[m.purchase_item_medicine].batches.push(m);
                                                                                acc[m.purchase_item_medicine].total_stock += batchStock;
                                                                                
                                                                                return acc;
                                                                            }, {});

                                                                        const availableMedicines = Object.values(medicineGroups)
                                                                            .filter(group => group.total_stock > 0);

                                                                        if (availableMedicines.length === 0) {
                                                                            return (
                                                                                <div className="dropdown-item text-muted">
                                                                                    {medicineSearch ? 'No medicines in stock' : 'Start typing to search...'}
                                                                                </div>
                                                                            );
                                                                        }

                                                                        return availableMedicines.map((m, index) => {
                                                                            const bestBatch = m.batches
                                                                                .filter(b => parseInt(b.purchase_item_qty_stock || 0) > 0)
                                                                                .sort((a, b) => {
                                                                                    const expA = `${a.purchase_item_expiry_year}-${String(a.purchase_item_expiry_month).padStart(2, '0')}`;
                                                                                    const expB = `${b.purchase_item_expiry_year}-${String(b.purchase_item_expiry_month).padStart(2, '0')}`;
                                                                                    return expB.localeCompare(expA);
                                                                                })[0];

                                                                            if (!bestBatch) return null;

                                                                            const expMonth = bestBatch.purchase_item_expiry_month || "N/A";
                                                                            const expYear = bestBatch.purchase_item_expiry_year || "N/A";

                                                                            return (
                                                                                <div
                                                                                    key={index}
                                                                                    className="dropdown-item"
                                                                                    onClick={() => handleMedicineSelect(bestBatch)}
                                                                                    style={{
                                                                                        cursor: 'pointer',
                                                                                        padding: '8px 12px',
                                                                                        borderBottom: '1px solid #eee'
                                                                                    }}
                                                                                >
                                                                                    <div><strong>{m.purchase_item_medicine}</strong></div>
                                                                                    <small className="text-muted">
    Batch:{" "}
    <span style={{ color: "#0d6efd", fontWeight: 600 }}>
        {bestBatch.purchase_item_batch}
    </span>{" "}
    | Total Stock:{" "}
    <span style={{ color: "#198754", fontWeight: 600 }}>
        {m.total_stock}
    </span>{" "}
    | MRP:{" "}
    <span style={{ color: "#8B4513", fontWeight: 600 }}>
        ₹{bestBatch.purchase_item_mrp}
    </span>
</small>

                                                                                </div>
                                                                            );
                                                                        });
                                                                    })()
                                                                ) : (
                                                                    <div className="dropdown-item text-muted">
                                                                        {medicineSearch ? 'No medicines found' : 'Start typing to search...'}
                                                                    </div>
                                                                )}
                                                            </div>
                                                        )}
                                                    </div>

                                                    <div className="col-2"></div>
                                                </div>
                                                <br />
                                                <div className="row">
                                                    <div className="col-lg-8">
                                                        <h5 style={{color: "rgb(64 81 137)"}}>Medicines</h5>
                                                    </div>
                                                </div>
                                                <br />
                                            </div>
                                            <div className="col-md-12">
   
                                                <div className="card-body pt-0">
                                                    <div>
                                                        <div className="table-responsive table-card mb-1">
                                                            <table className="table table-nowrap align-middle" id="orderTable">
                                                                <thead className="text-muted table-light">
                                                                    <tr className="text-uppercase">
                                                                        <th>S. No.</th>
                                                                        <th>medicines</th>
                                                                        <th style={{width: "200px"}}>Pack</th>
                                                                        <th>Batch / Expiry / Stock</th>
                                                                        <th>Quantity</th>
                                                                        <th style={{width: "150px !important"}}> Medicine MRP</th>
                                                                        <th>Discount(₹)</th>
                                                                        <th>Tax Amount</th>
                                                                        <th>Tax</th>
                                                                        <th>Total Amount</th>
                                                                        <th>Action</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody className="list form-check-all">
                                                                    {formData.medicines.map((item, index) => (
                                                                        item.med_bill_item_medicine && (
                                                                            <tr key={index}>
                                                                                <td>{index + 1}.</td>
                                                                                <td>{item.med_bill_item_medicine}</td>

                                                                                <td>
                                                                                    <select
                                                                                        className="form-control"
                                                                                        style={{ width: '100px' }}
                                                                                        name={`med_bill_item_is_loose${index}`}
                                                                                        value={item.med_bill_item_is_loose}
                                                                                        onChange={(e) => handleUnitChange(e, index)}
                                                                                    >
                                                                                        <option value="0">Package</option>
                                                                                        <option value="1">Loose</option>
                                                                                    </select>
                                                                                </td>

                                                                                {/* ✅ UPDATED BATCH DROPDOWN */}
                                                                                <td>
                                                                                    <select
                                                                                        className="form-control"
                                                                                        style={{ width: '280px' }}
                                                                                        value={item.med_bill_item_batch}
                                                                                        onChange={(e) => handleBatchChange(e, index)}
                                                                                    >
                                                                                        {item.available_batches &&
                                                                                            item.available_batches
                                                                                                .filter((batch) => {
                                                                                                    if (!batch.purchase_item_expiry_month || !batch.purchase_item_expiry_year) {
                                                                                                        return true;
                                                                                                    }

                                                                                                    const today = new Date();
                                                                                                    const currentYear = today.getFullYear() % 100;
                                                                                                    const currentMonth = today.getMonth() + 1;

                                                                                                    const expYear = parseInt(batch.purchase_item_expiry_year, 10);
                                                                                                    const expMonth = parseInt(batch.purchase_item_expiry_month, 10);

                                                                                                    if (expYear < currentYear) return false;
                                                                                                    if (expYear === currentYear && expMonth < currentMonth) return false;

                                                                                                    return true;
                                                                                                })
                                                                                                .map((batch, batchIndex) => {
                                                                                                    const expMonthName = batch.purchase_item_expiry_month
                                                                                                        ? monthNames[parseInt(batch.purchase_item_expiry_month) - 1]
                                                                                                        : "";
                                                                                                
                                                                                                    const expDateString = expMonthName && batch.purchase_item_expiry_year
                                                                                                        ? `${expMonthName}-${batch.purchase_item_expiry_year}`
                                                                                                        : "N/A";
                                                                                                
                                                                                                    const pkgStock = parseInt(batch.purchase_item_qty_stock || 0);
                                                                                                    const looseStock = parseInt(batch.purchase_item_tab_cap_stock || 0);
                                                                                                
                                                                                                    const displayStock =
                                                                                                        item.med_bill_item_is_loose === "1" ? looseStock : pkgStock;
                                                                                                
                                                                                                    const expired = isBatchExpired(
                                                                                                        batch.purchase_item_expiry_month,
                                                                                                        batch.purchase_item_expiry_year
                                                                                                    );
                                                                                                
                                                                                                    const isOutOfStock = displayStock <= 0;
                                                                                                
                                                                                                    const disabled = expired || isOutOfStock;
                                                                                                
                                                                                                    let label = `${batch.purchase_item_batch} | ${expDateString}`;
                                                                                                
                                                                                                    if (expired) {
                                                                                                        label += " | EXPIRED ❌";
                                                                                                    } else if (isOutOfStock) {
                                                                                                        label += " | OUT OF STOCK ❌";
                                                                                                    } else {
                                                                                                        label += ` | Avl: ${displayStock}`;
                                                                                                    }
                                                                                                
                                                                                                    return (
                                                                                                        <option
                                                                                                            key={batchIndex}
                                                                                                            value={batch.purchase_item_batch}
                                                                                                            disabled={disabled}
                                                                                                            style={{
                                                                                                                color: expired
                                                                                                                    ? '#6c757d'
                                                                                                                    : isOutOfStock
                                                                                                                    ? '#dc3545'
                                                                                                                    : 'inherit',
                                                                                                                fontWeight: disabled ? 'bold' : 'normal'
                                                                                                            }}
                                                                                                        >
                                                                                                            {label}
                                                                                                        </option>
                                                                                                    );
                                                                                                
                                                                                                })}
                                                                                    </select>
                                                                                </td>

                                                                                <td>
                                                                                    <div className="input-step">
                                                                                        <button type="button" className="minus"
                                                                                            onClick={() => {
                                                                                                let qty = Math.max(1, parseInt(item.med_bill_item_qty || 1) - 1);
                                                                                                handleChange1({ target: { name: `med_bill_item_qty${index}`, value: qty }}, index);
                                                                                            }}
                                                                                        > – </button>
                                                                                        
                                                                                        <input
                                                                                            type="number"
                                                                                            className="product-quantity"
                                                                                            value={item.med_bill_item_qty}
                                                                                            min="1"
                                                                                            onChange={(e) => {
                                                                                                const newQty = parseInt(e.target.value) || 1;
                                                                                                
                                                                                                let maxQty;
                                                                                                if (item.med_bill_item_is_loose === "0") {
                                                                                                    maxQty = parseInt(item.package_stock || item.med_bill_item_strips);
                                                                                                } else {
                                                                                                    maxQty = parseInt(item.loose_stock || item.med_bill_item_strips);
                                                                                                }

                                                                                                if (newQty > maxQty) {
                                                                                                    Swal.fire({
                                                                                                        icon: "warning",
                                                                                                        title: "Limit Reached!",
                                                                                                        text: `Maximum available quantity is ${maxQty}.`,
                                                                                                        timer: 2000
                                                                                                    });
                                                                                                    handleChange1({ target: { name: `med_bill_item_qty${index}`, value: maxQty }}, index);
                                                                                                } else {
                                                                                                    handleChange1({ target: { name: `med_bill_item_qty${index}`, value: newQty }}, index);
                                                                                                }
                                                                                            }}
                                                                                        />
                                                                                        
                                                                                        <button type="button" className="plus"
                                                                                            onClick={() => {
                                                                                                const currentQty = parseInt(item.med_bill_item_qty);
                                                                                                
                                                                                                let maxQty;
                                                                                                if (item.med_bill_item_is_loose === "0") {
                                                                                                    maxQty = parseInt(item.package_stock || item.med_bill_item_strips);
                                                                                                } else {
                                                                                                    maxQty = parseInt(item.loose_stock || item.med_bill_item_strips);
                                                                                                }

                                                                                                if (currentQty >= maxQty) {
                                                                                                    Swal.fire({
                                                                                                        icon: "warning",
                                                                                                        title: "Limit Reached!",
                                                                                                        text: `You cannot add more than the allowed quantity of ${maxQty}.`,
                                                                                                    });
                                                                                                    return;
                                                                                                }
                                                                                                
                                                                                                const newQty = currentQty + 1;
                                                                                                handleChange1({ target: { name: `med_bill_item_qty${index}`, value: newQty }}, index);
                                                                                            }}
                                                                                        > + </button>
                                                                                    </div>
                                                                                </td>

                                                                                <td style={{width: "100px !important"}}>
                                                                                    <input
                                                                                        type="text"
                                                                                        style={{width: "100px !important"}}
                                                                                        className="form-control"
                                                                                        value={item.med_bill_item_mrp}
                                                                                        readOnly
                                                                                    />
                                                                                </td>

                                                                                <td>
                                                                                    <input
                                                                                        type="text"
                                                                                        className="form-control"
                                                                                        style={{ width: '80px' }}
                                                                                        name={`med_bill_item_discount${index}`}
                                                                                        value={item.med_bill_item_discount}
                                                                                        onChange={(e) => handleChange1(e, index)}
                                                                                    />
                                                                                </td>

                                                                                <td>
                                                                                    <input
                                                                                        type="text"
                                                                                        className="form-control"
                                                                                        value={(() => {
                                                                                            const mrp = parseFloat(item.med_bill_item_mrp) || 0;
                                                                                            const qty = parseInt(item.med_bill_item_qty) || 0;
                                                                                            const discount = parseFloat(item.med_bill_item_discount) || 0;
                                                                                            const taxRate = parseFloat(item.med_bill_item_tax) || 0;

                                                                                            const subtotal = mrp ;
                                                                                            const afterDiscount = subtotal - discount;
                                                                                            const taxAmount = (afterDiscount * taxRate) / 100;

                                                                                            return taxAmount.toFixed(2);

                                                                                        })()}
                                                                                        readOnly
                                                                                    />
                                                                                </td>

                                                                                <td>GST {item.med_bill_item_tax}%</td>

                                                                                <td>
                                                                                    <input
                                                                                        type="text"
                                                                                        className="form-control"
                                                                                        value={(() => {
                                                                                            const mrp = parseFloat(item.med_bill_item_mrp) || 0;
                                                                                            const qty = parseInt(item.med_bill_item_qty) || 0;
                                                                                            const discount = parseFloat(item.med_bill_item_discount) || 0;
                                                                                            const taxRate = parseFloat(item.med_bill_item_tax) || 0;

                                                                                            const subtotal = mrp ;
                                                                                            const afterDiscount = subtotal - discount;
                                                                                            const taxAmount = (afterDiscount * taxRate) / 100;
                                                                                            const total = afterDiscount;

                                                                                            return total.toFixed(2);
                                                                                        })()}
                                                                                        readOnly
                                                                                    />
                                                                                </td>

                                                                                <td>
    <a
        href="#!"
        className="text-danger d-inline-block remove-item-btn"
        onClick={(e) => {
            e.preventDefault();
            const tmp = [...formData.medicines];
            tmp.splice(index, 1);
            setFormData((prev) => ({ ...prev, medicines: tmp }));
        }}
    >
        <i className="ri-delete-bin-5-fill fs-16"></i>
    </a>
</td>

                                                                            </tr>
                                                                        )
                                                                    ))}
                                                                </tbody>
                                                            </table>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-md-8">
                                                    <div className="mt-3">
                                                        <p className="d-flex justify-content-between">
                                                            <span>Total Qty</span>
                                                            <span>
                                                                <input
                                                                    type="number"
                                                                    className="form-control form-control-sm text-end"
                                                                    value={formData.total_qty || 0}
                                                                    readOnly
                                                                />
                                                            </span>
                                                        </p>

                                                        <p className="d-flex justify-content-between">
                                                            <span>Discount %</span>
                                                            <span>
                                                                <input
                                                                    type="number"
                                                                    className="form-control form-control-sm text-end"
                                                                    name="discount_percent"
                                                                    value={formData.discount_percent || ""}
                                                                    onChange={(e) => {
                                                                        const discountPercent = parseFloat(e.target.value) || 0;
                                                                        const discountAmt = ((parseFloat(formData.subtotal) || 0) * discountPercent) / 100;
                                                                    
                                                                        setFormData((prev) => ({
                                                                            ...prev,
                                                                            discount_percent: discountPercent,
                                                                            discount_on_all_amt: discountAmt.toFixed(2),
                                                                            grand_total: (
                                                                                parseFloat(prev.subtotal || 0) +
                                                                                parseFloat(prev.other_charges || 0) +
                                                                                parseFloat(prev.total_gst || 0) -
                                                                                discountAmt +
                                                                                parseFloat(prev.round_off || 0)
                                                                            ).toFixed(2),
                                                                        }));
                                                                    }}
                                                                />
                                                            </span>
                                                        </p>
                                                        <label>Paid</label>
                                                        <input
                                                            type="number"
                                                            className="form-control mb-2"
                                                            name="med_bill_paid"
                                                            onChange={handleChange}
                                                            value={formData.med_bill_paid}
                                                        />

                                                        <label>Payment Mode</label>
                                                        <select
                                                            className="form-control mb-2"
                                                            name="med_bill_payment_mode"
                                                            value={formData.med_bill_payment_mode}
                                                            onChange={handleChange}
                                                        >
                                                            <option value="cash">Cash</option>
                                                            <option value="online">Online</option>
                                                            <option value="card">Card</option>
                                                        </select>

                                                        <label>Remarks</label>
                                                        <textarea
                                                            className="form-control mb-2"
                                                            name="med_bill_remarks"
                                                            value={formData.med_bill_remarks}
                                                            onChange={handleChange}
                                                        />
                                                    </div>
                                                </div>

                                                <div className="col-md-4">
    <div className="card">
        <div className="card-body">
            <p className="d-flex justify-content-between">
                <span>Subtotal</span>
                <span>₹ {formData.subtotal || "0.00"}</span>
            </p>
            <p className="d-flex justify-content-between">
                <span>Other Charges</span>
                <span>₹ {formData.other_charges || "0.00"}</span>
            </p>
            <p className="d-flex justify-content-between">
                <span>Total GST</span>
                <span>₹ {formData.total_gst || "0.00"}</span>
            </p>
            <p className="d-flex justify-content-between text-danger">
                <span>Discount on All</span>
                <span>- ₹ {formData.discount_on_all_amt || "0.00"}</span>
            </p>
            <p className="d-flex justify-content-between" style={{
                color: parseFloat(formData.round_off || 0) >= 0 ? '#198754' : '#dc3545'
            }}>
                <span>Round Off</span>
                <span>
                    {parseFloat(formData.round_off || 0) >= 0 ? '+' : ''} ₹ {formData.round_off || "0.00"}
                </span>
            </p>
            <hr />
            <h5 className="d-flex justify-content-between">
                <span>Grand Total</span>
                <span>₹ {formData.grand_total || "0.00"}</span>
            </h5>
        </div>
    </div>
</div>
                                            </div>
                                        </div>
                                        <button type="submit" className="btn btn-primary w-100 mt-2">
                                            Save
                                        </button>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
       
       
       
       {/* ✅ EXPIRY ALERT MODAL */}
<div className={`modal fade ${showExpiryAlert ? 'show' : ''}`} 
     style={{ display: showExpiryAlert ? 'block' : 'none' }}
     tabIndex="-1">
    <div className="modal-dialog modal-xl modal-dialog-scrollable">
        <div className="modal-content">
            <div className="modal-header bg-warning text-dark">
                <h5 className="modal-title">
                    <i className="ri-alarm-warning-line me-2"></i>
                    Medicines Expiring Soon ({expiringMedicines.length})
                </h5>
                <button 
                    type="button" 
                    className="btn-close" 
                    onClick={() => setShowExpiryAlert(false)}
                ></button>
            </div>
            <div className="modal-body">
                {expiringMedicines.length > 0 ? (
                    <div className="table-responsive">
                        <table className="table table-bordered table-hover">
                            <thead className="table-warning">
                                <tr>
                                    <th>Sl. No.</th>
                                    <th>Medicine Name</th>
                                    <th>Supplier Name</th>
                                    <th>Batch No</th>
                                    <th>Package Qty</th>
                                    <th>Loose Qty</th>
                                    <th>Expiry Date</th>
                                    <th>Days Remaining</th>
                                    <th>Status</th>
                                </tr>
                            </thead>
                            <tbody>
                                {expiringMedicines.map((medicine, index) => {
                                    let statusClass = '';
                                    let statusText = '';
                                    let badgeClass = '';
                                    
                                    if (medicine.days_remaining <= 7) {
                                        statusClass = 'table-danger';
                                        statusText = 'Critical';
                                        badgeClass = 'badge bg-danger';
                                    } else if (medicine.days_remaining <= 15) {
                                        statusClass = 'table-warning';
                                        statusText = 'Warning';
                                        badgeClass = 'badge bg-warning text-dark';
                                    } else {
                                        statusClass = 'table-info';
                                        statusText = 'Notice';
                                        badgeClass = 'badge bg-info text-dark';
                                    }
                                    
                                    return (
                                        <tr key={index} className={statusClass}>
                                            <td>{index + 1}</td>
                                            <td><strong>{medicine.medicine_name}</strong></td>
                                            <td>{medicine.supplier_name}</td>
                                            <td>
                                                <span className="badge bg-secondary">
                                                    {medicine.batch_no}
                                                </span>
                                            </td>
                                            <td className="text-center">
                                                <span className="badge bg-primary">
                                                    {medicine.package_qty}
                                                </span>
                                            </td>
                                            <td className="text-center">
                                                <span className="badge bg-success">
                                                    {medicine.loose_qty}
                                                </span>
                                            </td>
                                            <td>{medicine.expiry_date}</td>
                                            <td>
                                                <strong>
                                                    {medicine.days_remaining} day{medicine.days_remaining !== 1 ? 's' : ''}
                                                </strong>
                                            </td>
                                            <td>
                                                <span className={badgeClass}>
                                                    {statusText}
                                                </span>
                                            </td>
                                        </tr>
                                    );
                                })}
                            </tbody>
                        </table>
                    </div>
                ) : (
                    <div className="text-center py-4">
                        <i className="ri-check-line text-success" style={{ fontSize: '48px' }}></i>
                        <p className="mt-3">No medicines expiring within 30 days</p>
                    </div>
                )}
            </div>
            <div className="modal-footer">
                <button 
                    type="button" 
                    className="btn btn-secondary" 
                    onClick={() => setShowExpiryAlert(false)}
                >
                    Close
                </button>
                <button 
                    type="button" 
                    className="btn btn-primary"
                    onClick={() => {
                        fetchExpiringMedicines();
                        toast.success("Expiry data refreshed");
                    }}
                >
                    <i className="ri-refresh-line me-1"></i> Refresh
                </button>
            </div>
        </div>
    </div>
</div>
{showExpiryAlert && <div className="modal-backdrop fade show"></div>}
       
       
        </div>
    );
}

export default AddSale2;